<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
export default {}
</script>
<style>
@import '../static/css/normalize@8.0.0/normalize.css';
@import '../static/css/shortcut@2.10/shortcut.css';
* {
  outline: none;
}

.container,.w1200 {
  width: 1200px;
  margin-left: auto;
  margin-right: auto;
}

.main-container {
  padding-bottom: 20px;
  background: #f2f2f2;
}

</style>




// WEBPACK FOOTER //
// src/App.vue